export default __webpack_public_path__ + "static/media/PuriBhaji.a3c4276b.jpg";